export const formatUserDisplayName = (user) => {
  if (!user) return '';

  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');

  if (name) return name;

  return user.email ?? '';
};
